/**
 * Format bytes as human-readable text.
 * 
 * @param bytes Number of bytes.
 * @param si True to use metric (SI) units, aka powers of 1000. False to use 
 *           binary (IEC), aka powers of 1024.
 * @param dp Number of decimal places to display.
 * 
 * @return Formatted string.
 */
 export function humanFileSize(bytes, si=false, dp=1) {
    const thresh = si ? 1000 : 1024;
  
    if (Math.abs(bytes) < thresh) {
      return bytes + ' B';
    }
  
    const units = si 
      ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] 
      : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
    let u = -1;
    const r = 10**dp;
  
    do {
      bytes /= thresh;
      ++u;
    } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);
  
  
    return bytes.toFixed(dp) + ' ' + units[u];
  }

  export function addressContractToInt(addressContract){
    return addressContract === "Owner" ? 1 : addressContract === "Tenant" ? 2 : 3;
  }

  export function addressTypeToInt(addressType){
    return addressType === "Apartment" ? 1 : addressType === "House" ? 2 : addressType === "Castle" ? 3 : addressType === "Hotel" ? 4 : addressType === "Houseboat" ? 5 : addressType === "SeniorResidence" ? 7 : 6;
  }

/**
 * Convert date to European human readable format (dd-MM-yyyy)
 * 
 * @param date javascript Date variable.
 * 
 * @return string formated with dd-MM-yyyy.
 */
  export function dateToString(date) {
    if(!(date instanceof Date)){
      return date.toString();
    }
    return date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'numeric', year: 'numeric' }).replace(/\//g, '-');
  }
/**
 * Convert a float to a currency string format
 * 
 * @param amount amount as a float
 * 
 * @return string amout in the format XX,CC.
 */
  export function formatAmount(amount) {
    if(amount === ''){
      return amount;
    }
    return amount.toFixed(2).replace(/\./g, ',');
  }